"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusStates = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const atom_1 = require("./atom");
const props_1 = require("../common/props");
/**
 * The focus states atom.
 * @category Atoms
 */
class FocusStates extends atom_1.Atom {
    constructor(atoms) {
        super("Focus States", false, atoms);
        this.addDependency(atoms.colorThemes);
        this.focusColor = new props_1.PropertyStringSelectable("Focus Color", false, this, { selectables: ["Theme Color", "Default Blue"] });
        this.addFocusBlur = new props_1.PropertyBoolean("Add focus blur?", false, this, { defaultValue: true });
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.focusColor.deserialize(obj.focusColor);
        this.addFocusBlur.deserialize(obj.addFocusBlur);
    }
    serialize() {
        const obj = {};
        obj.focusColor = this.focusColor.serialize();
        obj.addFocusBlur = this.addFocusBlur.serialize();
        return obj;
    }
}
exports.FocusStates = FocusStates;
